.prefix {
  overflow: hidden;

  > div {
    position: absolute;
  }
}
